import React, { useState } from 'react'
import {
  Box,
  Button,
  ButtonGroup,
  Grid2 as Grid,
  IconButton,
  InputAdornment,
  TablePagination,
  TextField,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SearchIcon from '@mui/icons-material/Search'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import CustomerInfoCard from './CustomerInfoCard'
import { useNavigate } from 'react-router-dom'
import StatusCard from '../../components/StatusCard'
import { ReactComponent as ProgressIcon } from '../../assets/icons/Inprogress.svg'
import { ReactComponent as RejectedIcon } from '../../assets/icons/Rejected.svg'
import { ReactComponent as ApprovalPendingIcon } from '../../assets/icons/Pending.svg'
import { ReactComponent as CompletedIcon } from '../../assets/icons/Completed.svg'
import { CARD_LAYOUT_OPTIONS } from '../../constants/constants'
import Colors from '../../utils/colors.json'
import ProfileCard from '../../components/ProfileCard'

export interface CustomerInfo {
  name: string
  phoneNumber: string
  avatar: string
  mrnNo: string
  abaId: string
  numberOfPeople: number
  labTestStatus: string
  physicalExamStatus: string
  receivedDate: string
  approvedDate: string
}

const styles = (theme: any) => ({
  peopleContainer: {
    flex: 1,
    overflowY: 'auto',
    // border: '1px solid grey',
    // borderRadius: '20px 20px 20px 20px',
  },
  filterBtn: {
    color: theme.palette.primary.main,
    background: '#F1F1F1',
    borderRadius: 20,
    textTransform: 'capitalize',
  },
  searchField: {
    fontSize: '12px !important',
    borderRadius: 20,
    height: 30,
  },
  cardPagination: {
    '& .MuiTablePagination-toolbar': {
      minHeight: 0,
      padding: '0 16px',
    },
  },
  selectedLayoutBtn: {
    color: Colors.WHITE_BACKGROUND,
    background: theme.palette.primary.main,
  },
})

const InvestigatingOfficer = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const classes = useCustomStyles(styles, theme)

  const filterCards = [
    {
      title: 'Approvals Pending',
      icon: <ApprovalPendingIcon />,
      count: 5,
      percentage: 2.5,
    },
    {
      title: 'In Progress',
      icon: <ProgressIcon />,
      count: 4,
      percentage: 2.5,
    },
    {
      title: 'Rejected',
      icon: <RejectedIcon />,
      count: 28,
      percentage: 2.5,
    },
    {
      title: 'Completed',
      icon: <CompletedIcon />,
      count: 20,
      percentage: 2.5,
    },
  ]

  const [cardLayout, setCardLayout] = useState(CARD_LAYOUT_OPTIONS.LIST)
  const [selectedFilterCard, setSelectedFilterCard] =
    useState('Approvals Pending')

  // eslint-disable-next-line
  const [openSlot, setOpenSlot] = useState(false)
  // eslint-disable-next-line
  const [customerData, setCustomerData] = useState<CustomerInfo[]>([
    {
      name: 'Anya Taylor',
      phoneNumber: '799983737',
      avatar: 'path/to/avatar1.jpg',
      mrnNo: '8989897',
      abaId: '638638',
      numberOfPeople: 4,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Completed',
      receivedDate: '12/12/1998',
      approvedDate: 'NA',
    },
    {
      name: 'John Doe',
      phoneNumber: '898123456',
      avatar: 'path/to/avatar2.jpg',
      mrnNo: '5674563',
      abaId: '456789',
      numberOfPeople: 2,
      labTestStatus: 'Pending',
      physicalExamStatus: 'In Progress',
      receivedDate: '01/01/2023',
      approvedDate: '05/01/2023',
    },
    {
      name: 'Emily Clark',
      phoneNumber: '701234567',
      avatar: 'path/to/avatar3.jpg',
      mrnNo: '1245789',
      abaId: '112233',
      numberOfPeople: 3,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Not Started',
      receivedDate: '15/07/2023',
      approvedDate: '20/07/2023',
    },
    {
      name: 'Michael Scott',
      phoneNumber: '798765432',
      avatar: 'path/to/avatar4.jpg',
      mrnNo: '8855447',
      abaId: '778899',
      numberOfPeople: 5,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Completed',
      receivedDate: '10/10/2020',
      approvedDate: '15/10/2020',
    },
    {
      name: 'Sarah Johnson',
      phoneNumber: '998123456',
      avatar: 'path/to/avatar5.jpg',
      mrnNo: '3344556',
      abaId: '998877',
      numberOfPeople: 1,
      labTestStatus: 'In Progress',
      physicalExamStatus: 'Completed',
      receivedDate: '05/03/2022',
      approvedDate: '10/03/2022',
    },
    {
      name: 'David Lee',
      phoneNumber: '667788990',
      avatar: 'path/to/avatar6.jpg',
      mrnNo: '7788990',
      abaId: '556677',
      numberOfPeople: 3,
      labTestStatus: 'Not Started',
      physicalExamStatus: 'Not Started',
      receivedDate: '20/08/2021',
      approvedDate: 'NA',
    },
    {
      name: 'Anya Taylor',
      phoneNumber: '799983737',
      avatar: 'path/to/avatar1.jpg',
      mrnNo: '8989897',
      abaId: '638638',
      numberOfPeople: 4,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Completed',
      receivedDate: '12/12/1998',
      approvedDate: 'NA',
    },
    {
      name: 'John Doe',
      phoneNumber: '898123456',
      avatar: 'path/to/avatar2.jpg',
      mrnNo: '5674563',
      abaId: '456789',
      numberOfPeople: 2,
      labTestStatus: 'Pending',
      physicalExamStatus: 'In Progress',
      receivedDate: '01/01/2023',
      approvedDate: '05/01/2023',
    },
    {
      name: 'Emily Clark',
      phoneNumber: '701234567',
      avatar: 'path/to/avatar3.jpg',
      mrnNo: '1245789',
      abaId: '112233',
      numberOfPeople: 3,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Not Started',
      receivedDate: '15/07/2023',
      approvedDate: '20/07/2023',
    },
    {
      name: 'Michael Scott',
      phoneNumber: '798765432',
      avatar: 'path/to/avatar4.jpg',
      mrnNo: '8855447',
      abaId: '778899',
      numberOfPeople: 5,
      labTestStatus: 'Completed',
      physicalExamStatus: 'Completed',
      receivedDate: '10/10/2020',
      approvedDate: '15/10/2020',
    },
    {
      name: 'Sarah Johnson',
      phoneNumber: '998123456',
      avatar: 'path/to/avatar5.jpg',
      mrnNo: '3344556',
      abaId: '998877',
      numberOfPeople: 1,
      labTestStatus: 'In Progress',
      physicalExamStatus: 'Completed',
      receivedDate: '05/03/2022',
      approvedDate: '10/03/2022',
    },
    {
      name: 'David Lee',
      phoneNumber: '667788990',
      avatar: 'path/to/avatar6.jpg',
      mrnNo: '7788990',
      abaId: '556677',
      numberOfPeople: 3,
      labTestStatus: 'Not Started',
      physicalExamStatus: 'Not Started',
      receivedDate: '20/08/2021',
      approvedDate: 'NA',
    },
  ])
  const [page, setPage] = React.useState(2)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  // eslint-disable-next-line
  const onCardClick = (customerDetails: any) => {
    navigate(`${process.env.PUBLIC_URL}/customerDetails`)
  }

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <Grid
      container
      height={'100%'}
      width={'100%'}
      direction={'column'}
      spacing={2}
      // overflow={'hidden'}
    >
      <Grid container direction={'row'} spacing={1.5}>
        {filterCards?.map((item, index) => (
          <Grid size={{ xs: 3 }} key={index}>
            <StatusCard
              icon={item?.icon}
              title={item?.title}
              count={item?.count}
              percentage={item?.percentage}
              selected={selectedFilterCard === item?.title ? true : false}
              onClick={() => setSelectedFilterCard(item?.title)}
            />
          </Grid>
        ))}
      </Grid>

      <Grid
        container
        spacing={5}
        direction={'row'}
        position={'sticky'}
        top={0}
        zIndex={1}
        size={{ xs: 12 }}
        pr={2}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            flexWrap={'wrap'}
            rowGap={2}
            gap={4}
          >
            <Button
              variant='contained'
              className={classes?.filterBtn}
              endIcon={<KeyboardArrowDownIcon />}
              size='small'
            >
              Contacted - 9
            </Button>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'end'}
            flexWrap={'wrap'}
            gap={4}
            rowGap={2}
          >
            <TextField
              placeholder='Search for Customers'
              type='search'
              size='small'
              slotProps={{
                input: {
                  className: classes?.searchField,
                  startAdornment: (
                    <InputAdornment position='start'>
                      <IconButton size='small'>
                        <SearchIcon fontSize='small' />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              variant='contained'
              className={classes?.filterBtn}
              startIcon={<FilterAltIcon />}
              size='small'
            >
              Filter
            </Button>
            <ButtonGroup>
              <Button
                variant='contained'
                className={`${classes?.filterBtn} ${
                  cardLayout === CARD_LAYOUT_OPTIONS.GRID
                    ? classes?.selectedLayoutBtn
                    : ''
                }`}
                size='small'
                onClick={() => setCardLayout(CARD_LAYOUT_OPTIONS.GRID)}
              >
                <ViewModuleIcon fontSize='small' />
              </Button>
              <Button
                variant='contained'
                className={`${classes?.filterBtn}  ${
                  cardLayout === CARD_LAYOUT_OPTIONS.LIST
                    ? classes?.selectedLayoutBtn
                    : ''
                }`}
                size='small'
                onClick={() => setCardLayout(CARD_LAYOUT_OPTIONS.LIST)}
              >
                <FormatListBulletedIcon fontSize='small' />
              </Button>
            </ButtonGroup>
          </Box>
        </Grid>
      </Grid>
      <Grid
        className={classes?.peopleContainer}
        pr={2}
        size={{ xs: 12 }}
        direction={'column'}
      >
        {cardLayout === CARD_LAYOUT_OPTIONS.LIST ? (
          <Grid container spacing={1.5} direction={'column'} size={{ xs: 12 }}>
            {customerData?.map((item, index) => (
              <CustomerInfoCard
                key={index}
                data={item}
                onClick={() => onCardClick(item)}
              />
            ))}
          </Grid>
        ) : (
          <Grid container spacing={4} direction={'row'} pb={3}>
            {Array.from({ length: 5 }).map((item, index) => (
              <Grid key={index} size={{ xs: 6, lg: 6, xl: 4, md: 6, sm: 12 }}>
                <ProfileCard onClick={() => onCardClick(item)} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TablePagination
          className={classes?.cardPagination}
          component='div'
          count={100}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  )
}

export default InvestigatingOfficer
